import { Translations } from './fr';

export const en: Translations = {
    testKey: 'testValueEN',
    testKeyNested: { deepTranslation: 'deepTranslationEN' },
    Lang: 'en',
    Tester: 'Try',
    rules: {
        welcome: 'Looking for adventures ?',
        howTo:
            'Move yourself with the arrow keys.\nUse space to jump.\nP to pause.\n\nReach the last level for\nsaving & sharing your score !',
        end: 'Atteignez le dernier niveau afin de\nsauvegarder et partager votre score !',
        start: 'Push space to start',
        runAway: "Don't get hit by the night !",
    },
    Retour: 'Back',
    Editeur: 'Make your own level',
    Jeu: 'Play the game',
    Ou: 'Or ...',
    Menu: 'Menu',
    Victoire: 'VICTORY !',
    Enregistrement: 'Save the actual score',
    HowToBack: '(Come back to this menu with Escape)',
    RaZ: 'Reset',
    points: 'points',
    Pseudo: 'Enter your name and confirm with .. enter!',
    backToMenu: 'Back to the menu',
    Scores: 'Highscores',
    Difficultes: {
        easy: 'Easy',
        normal: 'Normal',
        hard: 'Hard',
        nightmare: 'Nightmare',
    },
    UnSeul: 'Score / Pseudo / Number of stages',
};
